import styled from 'styled-components';

export default styled.div`
  flex: 0 0 32px;
  background-color: var(--grey300);
  color: var(--grey900);
  font-weight: bold;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 4px 4px 0 0;
`;
